import React, { Component } from "react";
import ReactDOM from 'react-dom';
import { getMultiLang, getSysFieldid, myBrowser, getGlobalStorage } from '@platform/api';
import { Table } from '@platform/base';
import { getTotalData, getTotalScale, getFinalTotalData, getTotalColumns, addBlankCol } from './util'
import './index.less';
import { isFunction } from "../../utils";
import classnames from 'classnames';
// tinper提供的计算滚动条宽度的方法
import { measureScrollbar } from "bee-table/build/lib/utils"

const totalTableHeight = 28;

export default function total(HighTable) {
    return class ModalTable extends Component {
        constructor(props) {
            super(props);
            this.state = { json: {}, }
            this.browser = myBrowser()
            // this.bodyColumn = props.columns
            this.finalColumns = [];
            this.totalData = [];
        }
        UNSAFE_componentWillMount() {
            let callback = json => {
                this.setState({ json });
            };
            getMultiLang({ moduleId: 'page_table', callback });
        }
        componentDidMount() {
            const { isTotal } = this.props
            isTotal && this.addScrollEvent();
            isTotal && this.hidebodyScrollbar();
            window.addEventListener('resize', this.hidebodyScrollbar)
            let fontSize = getGlobalStorage('localStorage', 'nccFontSize')
            if (fontSize === 'large') {
                this.setState({ fontSize: 'large' })
            }
        }
        // UNSAFE_componentWillReceiveProps(nextprops) {
        //     this.bodyColumn = nextprops.columns;
        // }
        componentDidUpdate() {
            const { isTotal } = this.props
            isTotal && this.addScrollEvent();
            isTotal && this.hidebodyScrollbar();

        }
        componentWillUnmount() {
            this.total = null;
            const { isTotal } = this.props
            isTotal && this.removeScrollEvent();
            window.removeEventListener('resize', this.hidebodyScrollbar)
        }
        // 添加滚动事件
        addScrollEvent() {
            //每次重新绑定
            this.removeScrollEvent();
            let totalArea = this.total && this.total.querySelector('.u-table-body');
            // let totalInnerArea = this.total && this.total.querySelector('.u-table-body table');
            totalArea && totalArea.addEventListener('scroll', this.addTotalAreaScrollEvent);
            // totalInnerArea && totalInnerArea.addEventListener('scroll', this.addTotalInnerAreaScrollEvent);

            //最新优化---解决bee-table滚动条重置后，合计滚动条不联动，场景：横向滚动条拖动到最后，新增行，合计滚动条scrollLeft不变
            let bodyArea = this.table && this.table.querySelector('.u-table-body');
            let headerArea = this.table && this.table.querySelector('.u-table-content .u-table-scroll .u-table-header');
            headerArea = headerArea || bodyArea;
            headerArea && headerArea.addEventListener('scroll', this.addHeaderAreaScrollEvent);

            // 目的是解决 火狐浏览器下 滚动条事件失效问题 NCCLOUD-163960
            if (myBrowser() == 'Firefox' && totalArea) {
                requestAnimationFrame(function () {
                    totalArea.style.overflowX = 'auto';
                    totalArea.style.marginBottom = '0px';
                });
                totalArea.style.marginBottom = '17px';
                totalArea.style.overflowX = 'hidden';
            }
        }

        addHeaderAreaScrollEvent = () => {
            let totalArea = this.total && this.total.querySelector('.u-table-body');
            let headerArea = this.table && this.table.querySelector('.u-table-content .u-table-scroll .u-table-header');
            //表头滚动条事件
            try {
                if (totalArea) totalArea.scrollLeft = headerArea.scrollLeft;
            } catch (e) {
                console.warn(e);
            }
        }

        addTotalAreaScrollEvent = () => {
            let totalArea = this.total && this.total.querySelector('.u-table-body');
            let bodyArea = this.table && this.table.querySelector('.u-table-body');
            let headerArea = this.table && this.table.querySelector('.u-table-content .u-table-scroll .u-table-header');
            //合计行滚动条事件

            if (totalArea) {
                if (bodyArea) bodyArea.scrollLeft = totalArea.scrollLeft;
                if (headerArea) headerArea.scrollLeft = totalArea.scrollLeft;
            }
        }
        addTotalInnerAreaScrollEvent = () => {
            let totalInnerArea = this.total && this.total.querySelector('.u-table-body table');
            let bodyArea = this.table && this.table.querySelector('.u-table-body table');
            let headerArea = this.table && this.table.querySelector('.u-table-content .u-table-scroll .u-table-header');
            //合计行滚动条事件
            if (totalInnerArea) {
                if (bodyArea) bodyArea.scrollLeft = totalInnerArea.scrollLeft;
                if (headerArea) headerArea.scrollLeft = totalInnerArea.scrollLeft;
            }
        }
        // 去除滚动事件
        removeScrollEvent() {
            let totalArea = this.total && this.total.querySelector('.u-table-body');
            // let totalInnerArea = this.total && this.total.querySelector('.u-table-body table');
            totalArea && totalArea.removeEventListener('scroll', this.addTotalAreaScrollEvent);
            // totalInnerArea && totalInnerArea.removeEventListener('scroll', this.addTotalInnerAreaScrollEvent);

            let bodyArea = this.table && this.table.querySelector('.u-table-body');
            let headerArea = this.table && this.table.querySelector('.u-table-content .u-table-scroll .u-table-header');
            headerArea = headerArea || bodyArea;
            headerArea && headerArea.removeEventListener('scroll', this.addHeaderAreaScrollEvent);

        }
        onDropBorderHandler = () => {
            if (!this.total) {
                return
            }
            // let th = this.table.querySelectorAll('.nc-table:not(.total-row) >div.u-table-content >div.u-table-scroll >div:nth-child(1) .u-table-body table colgroup col');
            // let totalBody = this.total.querySelectorAll('.u-table-scroll .u-table-body colgroup col');
            // let length = th?.length || 0;
            // for (let i = 0, len = length; i < len; i++) {
            //     let newWidth = th[i] && th[i].style.width;
            //     if (totalBody[i]) {
            //         totalBody[i].style.width = newWidth;
            //         totalBody[i].style.minWidth = newWidth;
            //     }
            // }
            let footerBody = this.total && this.total.querySelector('.u-table-body')
            footerBody.style.overflowX = 'auto';
            this.hidebodyScrollbar();
            // this.bodyColumn = newColumn;
        };

        onDraggingBorder = () => {
            let th = this.table.querySelectorAll('.nc-table:not(.total-row) >div.u-table-content >div.u-table-scroll >div:nth-child(1) .u-table-body table colgroup col');
            let totalBody = this.total && this.total.querySelectorAll('.u-table-scroll .u-table-body colgroup col');
            for (let i = 0, len = th.length; i < len; i++) {
                let newWidth = th[i] && th[i].style.width;
                if (totalBody[i]) {
                    totalBody[i].style.width = newWidth;
                }
                if (typeof newWidth === 'string') {
                    newWidth = Number(newWidth.match(/\d+/g)[0]);
                }
            }
            let footerBody = this.total && this.total.querySelector('.u-table-body table');
            if (footerBody) { footerBody.style.overflowX = 'auto' }
            this.hidebodyScrollbar();
            isFunction(this.props.onDraggingBorder) && (this.props.onDraggingBorder())
        };

        haveHorizontalScrollBar = () => {
            let outbody = this.total && this.total.querySelector('.u-table-body');
            if (outbody) {
                let innerbody = outbody.querySelector('table');
                if (innerbody) {
                    return innerbody.offsetWidth > outbody.offsetWidth
                } else {
                    return false
                }

            }
        }

        haveVerticalScrollBar = () => {
            let uTableScroll = this.total && this.total.parentNode.parentNode.parentNode;
            if (uTableScroll) {
                let offsetHeight = uTableScroll.querySelector('.u-table-scroll .u-table-body')?.offsetHeight;
                let scrollHeight = uTableScroll.querySelector('.u-table-scroll .u-table-body')?.scrollHeight;
                return scrollHeight > offsetHeight
            }
            return false
        }

        //当有合计行时并且出现横向滚动条的时候，将合计行上移，盖住body部分的横向滚动条
        hidebodyScrollbar = () => {
            if (!this.total) { return }
            let tableFooter = this.total
            if (this.haveHorizontalScrollBar()) {
                if (tableFooter) {
                    if (this.browser === 'Firefox' || this.browser === 'IE' || this.browser === 'Edge') {
                        tableFooter.style.marginTop = '-17px';
                    } else {
                        tableFooter.style.marginTop = '-10px';
                    }

                    tableFooter.className = tableFooter.className.replace(/total-table-has-scroll-y/gi, '');

                    if (this.haveVerticalScrollBar()) {
                        tableFooter.style.paddingRight = measureScrollbar() + 'px';
                        tableFooter.className += ' total-table-has-scroll-y';
                    } else {
                        tableFooter.style.paddingRight = '0px';
                    }
                }
                //用于合计行文字上下居中 NCCLOUD-191974
                let totalTd = this.total.querySelectorAll('td');
                if (totalTd && totalTd.length) {
                    for (let i = 0, len = totalTd.length; i < len; i++) {
                        if (this.browser === 'Firefox' || this.browser === 'IE' || this.browser === 'Edge') {
                            totalTd[i].style.paddingTop = '5px';
                        } else {
                            totalTd[i].style.paddingTop = '10px';
                        }
                    }
                }
            } else if (!this.haveHorizontalScrollBar()) {
                if (tableFooter) {
                    tableFooter.style.marginTop = '0px';
                    // 解决NCC-93556问题，在拖动滚动条时，overflowX值发生变化导致重绘
                    // let footerBody = tableFooter.querySelector('.u-table-body table')
                    // if (footerBody) {
                    //     footerBody.style.overflowX = 'visible';
                    // }
                    tableFooter.style.paddingRight = '0px';

                    tableFooter.className = tableFooter.className.replace(/total-table-has-scroll-y/gi, '');

                    if (this.haveVerticalScrollBar()) {
                        // tableFooter.style.paddingRight = measureScrollbar() + 'px';
                        tableFooter.className += ' total-table-has-scroll-y';
                    } else {
                        tableFooter.style.paddingRight = '0px';
                    }
                }
                let totalTd = this.total.querySelectorAll('td');
                if (totalTd && totalTd.length) {
                    for (let i = 0, len = totalTd.length; i < len; i++) {
                        totalTd[i].style.paddingTop = '0px';
                    }
                }

            }
        }

        handleFooter = (columns) => {
            let { data, totalConfig = {}, checkColConfig = {}, inserttableTotalConfig, numberPd, cardType } = this.props
            let finalColumns = []
            let totalData = {}
            if ((cardType === 'simple' || cardType === 'edit') && (window.updateTrigger || window.updateBodyScrollTrigger)) {
                totalData = this.totalData;
                finalColumns = this.finalColumns;
            } else if (inserttableTotalConfig) {
                // 转单  以及  insertTable
                finalColumns = inserttableTotalConfig.totalColumns
                totalData = inserttableTotalConfig.totalData

                // 解决一下 空白列  及拖拽列宽
                let blankrowFlag = true;
                if (finalColumns.length) {
                    const columnsTempObj = {};
                    columns?.forEach((element, i) => {
                        columnsTempObj[element.attrcode || element.dataIndex] = element;
                    })
                    finalColumns.forEach(element => {
                        if (element.attrcode == 'blankrow') {
                            blankrowFlag = false;
                        }
                        let item = columnsTempObj[element.attrcode || element.dataIndex];
                        if (item) {
                            element.width = item.width;
                        }
                    });
                    if (blankrowFlag) {
                        let obj = {
                            title: <div className={'fake-line'} />,
                            key: 'blankrow',
                            dataIndex: 'blankrow',
                            attrcode: 'blankrow',
                            className: 'blankrow',
                            visible: true,
                            itemtype: 'customer',
                            width: "1px",
                            render: () => <div />,
                        };
                        finalColumns.push(obj);
                    }
                }
            } else {
                const { json } = this.state
                //获得合计行的 items
                // finalColumns = getTotalColumns(this.columnAfterDrop || this.bodyColumn, { numberPd: totalConfig.numberPd });
                finalColumns = getTotalColumns(columns, { numberPd: totalConfig.numberPd });
                // 获得 每一列的精度
                let totalScale = getTotalScale(finalColumns, data)
                //合计行的data
                totalData = getTotalData(finalColumns, data, totalConfig, totalScale || {});
                if (totalScale !== null) {
                    // 获取合计行进行精度处理后的数据
                    totalData = getFinalTotalData(totalData[0], totalScale);
                }

                //totalData = this.formNumber(totalData);

                //合计文字
                let totalName = totalConfig.totalName || json['table002'];
                if(checkColConfig.showCheck){
                    totalData[0].checkbox = totalName;
                }else{
                    totalData[0].numberindex = totalName;
                }
            }

            this.totalData = totalData;
            this.finalColumns = finalColumns;

            return (
                <div fieldid={getSysFieldid('total-row')}>
                    <Table
                        minColumnWidth={80}
                        height={totalTableHeight}
                        ref={dom => {
                            this.total = ReactDOM.findDOMNode(dom);
                        }}
                        className={classnames('total-row',
                            { 'total-first-col-padding': this.state.fontSize }, //字体变大，合计两个字会被遮挡
                        )}
                        addBlankCol={false}
                        data={totalData}
                        columns={[...finalColumns]}
                        rowKey={'total-row'}
                        showHeader={false}
                        headerScroll={false}
                        scroll={{}}

                        bodyStyle={{ minHeight: totalTableHeight, overflowX: 'auto' }}
                    />
                </div>
            );
        };

        render() {
            const { isTotal, onBodyScroll } = this.props
            if (isTotal) {
                return (<HighTable
                    {...this.props}
                    handleFooter={(columns) => this.handleFooter(columns)}
                    setCellValue={params => {
                        // 暂时先去除
                        // this.forceUpdate()
                        // this.setState({});
                        isFunction(this.props.setCellValue) && (this.props.setCellValue(params))

                    }}
                    ref={dom => {
                        this.table = ReactDOM.findDOMNode(dom);
                    }}
                    // onDropAfter={newColumn => { this.columnAfterDrop = newColumn }}
                    onDropBorderHandler={() => { this.onDropBorderHandler() }}
                    onBodyScroll={scrollTop => {
                        window.updateBodyScrollTrigger = true;
                        window.requestAnimationFrame(() => {
                            console.log('updateBodyScrollTrigger');
                            window.updateBodyScrollTrigger = false;
                        });

                        onBodyScroll && onBodyScroll(scrollTop);
                    }}
                />)
            } else {
                return <HighTable {...this.props} />
            }
        }

    }
}